<template>
  <dialogVue :visible="visible" @closeClick="handleCloseClick">
    <div class="memo__help__dialog">
      <el-carousel
        @change="handleChange"
        trigger="click"
        indicator-position="outside"
        height="420px"
        arrow="never"
        :autoplay="false"
        ref="carousel"
        :initial-index="0"
      >
        <el-carousel-item v-for="(item, index) in imgList" :key="index">
          <div style="text-align: center; width: 100%; height: 100%">
            <div class="memo__help__dialog__carousel__header">
              <div class="memo__help__dialog__carousel__header--title">{{ item.title }}</div>
              <div class="memo__help__dialog__carousel__header--desc">
                {{ item.desc }}
              </div>
            </div>
            <img :src="item.img" alt="" />
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="memo__help__dialog__action" @click="handleNext">
        {{
          currentIndex == imgList.length - 1
            ? $t('onboarding.dialogs.action.done')
            : $t('onboarding.dialogs.action.next')
        }}
      </div>
    </div>
  </dialogVue>
</template>
<script>
import dialogVue from './dialog.vue'
import logClickEvent from '../../../utils/logClickEvent'
import { getDurationRange } from '../../../utils/utils'
export default {
  name: 'tagDialog',
  components: {
    dialogVue,
  },
  computed: {
    me() {
      return this.$store.state.me
    },
    visible() {
      return this.$store.getters['onboarding/tagHelpDialog'] == 1
    },
    isDark() {
      return document.body.classList.contains('dark_mode')
    },
    isZh() {
      return this.me ? this.me.language !== 'en' : true
    },
    imgList() {
      return [
        {
          img: `https://flomo-resource.oss-accelerate.aliyuncs.com/onboarding/tag_${this.isDark ? 'dark' : 'light'}_${
            this.isZh ? 'zh' : 'en'
          }_1.png`,
          title: this.$t('onboarding.dialogs.tagHelp.title1'),
          desc: this.$t('onboarding.dialogs.tagHelp.desc1'),
        },
        {
          img: `https://flomo-resource.oss-accelerate.aliyuncs.com/onboarding/tag_${this.isDark ? 'dark' : 'light'}_${
            this.isZh ? 'zh' : 'en'
          }_2.png`,
          title: this.$t('onboarding.dialogs.tagHelp.title2'),
          desc: this.$t('onboarding.dialogs.tagHelp.desc2'),
        },
        {
          img: `https://flomo-resource.oss-accelerate.aliyuncs.com/onboarding/tag_${this.isDark ? 'dark' : 'light'}_${
            this.isZh ? 'zh' : 'en'
          }_3.png`,
          title: this.$t('onboarding.dialogs.tagHelp.title3'),
          desc: this.$t('onboarding.dialogs.tagHelp.desc3'),
        },
      ]
    },
  },
  data() {
    return {
      currentIndex: 0,
      startTime: 0,
    }
  },
  methods: {
    handleCloseClick() {
      logClickEvent('标签_提示详情', '关闭')
      this.closeClick()
    },
    handleChange(val) {
      logClickEvent('标签_提示详情', '滑动')
      this.currentIndex = val
    },
    closeClick() {
      let endTime = new Date().getTime()
      let duration = endTime - this.startTime
      const durationRange = getDurationRange(duration)
      logClickEvent('标签_提示详情', '在此页面停留时长', durationRange)
      this.$store.dispatch('onboarding/setTagHelpDialog', '0')
    },
    handleNext() {
      if (this.currentIndex == this.imgList.length - 1) {
        logClickEvent('标签_提示详情', '完成')
        this.closeClick()
      } else {
        logClickEvent('标签_提示详情', '下一条')
        this.$refs.carousel.next()
      }
    },
  },
  watch: {
    visible(val) {
      if (val) {
        // 计算显示时长
        this.startTime = new Date().getTime()
      }
    },
  },
}
</script>
